import { render, staticRenderFns } from "./practice_attendance_report.vue?vue&type=template&id=2472d9fc&"
import script from "./practice_attendance_report.vue?vue&type=script&lang=js&"
export * from "./practice_attendance_report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports